import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation } from '@tanstack/react-query';

export const useApplicationMutations = () => {
  const { axios } = useNetworkRequest();

  const { mutate: nextStep, isLoading: nextLoading } = useMutation(() =>
    axios.patch(`/v3/professional/application_wizard/next`),
  );

  const { mutate: nextStepWithValues, isLoading: nextWithValuesLoading } = useMutation(
    (values: unknown) => axios.patch(`/v3/professional/application_wizard/next`, values),
  );

  const { mutate: prevStep, isLoading: prevLoading } = useMutation(() => {
    return axios.patch(`/v3/professional/application_wizard/back`);
  });

  return {
    nextStep,
    nextStepWithValues,
    prevStep,
    isLoading: nextLoading || prevLoading || nextWithValuesLoading,
  };
};
